import ToolbarButtonWithDropdown from '../ToolbarButtonWithDropdown';
import { LineHeightPicker } from '../pickers';

export default function LineHeightButton({ editor, position }) {
  const handleChangeLineHeight = (value) => {
    editor.chain().focus().setLineHeight(value).run();
  };

  return (
    <ToolbarButtonWithDropdown
      position={position}
      disabled={!editor.can().chain().focus().setLineHeight().run()}
      dropdownComponent={<LineHeightPicker onClick={handleChangeLineHeight} />}
      aria-label="editor-line-height"
    >
      Tᛨ
    </ToolbarButtonWithDropdown>
  );
}
